import { styled } from "@mui/material";
import MuiListItemButton, { ListItemButtonProps as MuiListItemButtonProps } from "@mui/material/ListItemButton";

interface ListItemButtonProps extends MuiListItemButtonProps {
    status?: "active";
}

const AppListItemButton = styled(
    MuiListItemButton,
    {}
)<ListItemButtonProps>(({ theme, status }) => ({
    margin: "5px 0 5px 5px",
    backgroundColor: "transparent !important",
    "&:hover": {
        backgroundColor: "transparent",
    },
    ...(status !== "active" && {
        color: theme.palette.text.secondary,
    }),
}));

export default AppListItemButton;
